import {createContext, useContext} from 'react';
import {AxiosInstance} from 'axios';
import {USER_TYPE} from '@/utils/enums';

interface ApiContextValue {
	apiInstance: AxiosInstance;
	role: USER_TYPE;
}

const ApiInstanceContext = createContext<ApiContextValue | null>(null);

export const ApiInstanceProvider = ApiInstanceContext.Provider;

export const useApiInstance = (): ApiContextValue => {
	const context = useContext(ApiInstanceContext);
	if (!context) {
		throw new Error('useApiInstance must be used within an ApiInstanceProvider');
	}
	return context;
};
